module.exports = __webpack_public_path__ + "img/logincont.af4bb30e.png";